/**
 * flights — part of the German catalogue (the reference language).
 * Merged in `i18n/de.ts`; every key here must exist in `i18n/en/flights.ts`.
 */

export const flights = {
  /* ---------------- the flight list ---------------- */
  'flights.title': 'Flüge',
  'flights.new': 'Neuer Flug',
  'flights.newTemplate': 'Neue Vorlage',
  'flights.templates': 'Vorlagen',
  'flights.template': 'Vorlage',
  'flights.untitled': 'ohne Titel',
  'flights.noRoute': 'Ohne Strecke',
  'flights.today': 'Heute',
  'flights.undated': 'Ohne Datum',
  'flights.empty.title': 'Noch kein Flug geplant.',
  'flights.empty.line': 'Ein Flug beginnt mit zwei Plätzen auf der Karte.',
  'flights.error': 'Die Flüge lassen sich gerade nicht laden.',
  'flights.retry': 'Erneut versuchen',
  /* the ⋯ menu on a row */
  'flights.menu': 'Weitere Aktionen',
  'flights.open': 'Öffnen',
  'flights.return': 'Rückflug anlegen',
  'flights.duplicate': 'Duplizieren',
  'flights.saveTemplate': 'Als Vorlage sichern',
  'flights.instantiate': 'Flug daraus anlegen',
  'flights.rename': 'Umbenennen',
  'flights.rename.prompt': 'Neuer Titel',
  'flights.delete': 'Löschen',
  'flights.confirm.delete': '„{title}“ löschen?',
} as const;
